import { Box, breakpoint } from '@bfa/common-ui';
import styled from 'styled-components';

export const GbxOneClickMainContainer = styled(Box)`
  margin: 0 auto 8rem;
  max-width: 55.8rem;
  text-align: center;
`;

export const TextMainContainer = styled(Box)`
  margin-top: 2rem;

  @media only screen and (min-width: ${breakpoint('sm')}) {
    margin-top: 3.2rem;
  }
`;
